import React, {useEffect, createRef} from 'react';
import { BsChevronDown } from 'react-icons/bs';
import {
  SelectInputSelector,
  SelectShowOptionSelectedMessageError,
  SelectShowOptionSelect,
  SelectShowOptionSelected,
  SelectShowOptionContent,
  SelectShowOptionSelectOption,
  SelectContainer,
  SelectLabel,
} from './styles';

const Select = ({ error, name, id, setShow, show, label, disabled, placeholder, defaultValue, setSelected, list, register }) => {
  const ref = createRef();
  const checkIfClickedOutside = e => {
    if (show && ref.current && !ref.current.contains(e.target)) {
      setShow(false);
    }
  }
  function agregarEvento(){
    document.addEventListener("mousedown", checkIfClickedOutside)
  }
  useEffect(() => {
    agregarEvento();
    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", checkIfClickedOutside)
    }
  }, [show])
  return (
    <SelectContainer id="select" ref={ref}>
      <SelectLabel>{label}</SelectLabel>
      <SelectShowOptionSelect open={show} className={error && 'error'} onClick={() => !disabled && setShow(!show)} disabledField={disabled}>
        <SelectShowOptionSelected className={!defaultValue ? 'default' : ''}>{!defaultValue ? placeholder : defaultValue}</SelectShowOptionSelected>
        <BsChevronDown />
        <SelectShowOptionContent open={show}>
          {list.map((item, key) => (
            <SelectShowOptionSelectOption onClick={() => setSelected(item, name)} key={key} id={`option${key}`}>{item.nombre}</SelectShowOptionSelectOption>
          ))}
        </SelectShowOptionContent>
      </SelectShowOptionSelect>
      {error && <SelectShowOptionSelectedMessageError error={error}>{error.message}</SelectShowOptionSelectedMessageError>}
      <SelectInputSelector type="text" name={name} id={id} defaultValue={defaultValue} ref={register} />
    </SelectContainer>
  )
}

export default Select
